import { delay, HttpResponse } from "msw";

export const postAskGpcChatMessage = async () => {
  await delay("real");
  return HttpResponse.json({
    question_id: "7196e193-1a14-489c-9679-0806415e436f",
    question_timestamp: "2025-04-02T21:18:22.441751Z",
    answer: "Elaborative answer from RAG-based solution. Not from a mock at all.",
    is_truncated: false,
  });
};
